import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@material-ui/core';
import medicionesStyles from './medicionesStyles';

/**
 * Campo numérico con unidad y mensaje de validación. Es type="text" con
 * inputMode decimal: así se distingue "vacío" de "no numérico" y se acepta coma.
 */
const CampoMedicion = ({ id, label, unidad, value, onChange, error, disabled, readOnly, ayuda }) => {
	const classes = medicionesStyles();

	return (
		<TextField
			id={id}
			label={label}
			value={value ?? ''}
			variant="outlined"
			fullWidth
			type="text"
			disabled={disabled}
			inputProps={{ inputMode: 'decimal', autoComplete: 'off', readOnly }}
			onChange={(e) => {
				if (!readOnly && onChange) {
					onChange(e.target.value);
				}
			}}
			error={Boolean(error)}
			helperText={error || ayuda || ' '}
			InputProps={{ endAdornment: <InputAdornment position="end">{unidad}</InputAdornment> }}
			className={readOnly ? `${classes.campoMedicion} ${classes.campoSoloLectura}` : classes.campoMedicion}
		/>
	);
};

CampoMedicion.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	unidad: PropTypes.string.isRequired,
	value: PropTypes.string,
	onChange: PropTypes.func,
	error: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	// Texto de ayuda permanente bajo el campo; el error tiene prioridad sobre él
	ayuda: PropTypes.string,
};

CampoMedicion.defaultProps = {
	readOnly: false,
};

export default CampoMedicion;
